import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LayoutParams } from './../../config/LayoutParams';
import { downloadBase64File } from './../../utils/Functions';

export default class InstaladorView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lista: [],
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      const res = await this.props.api.get('/instalador');

      const lista =
        res?.itens ??
        res?.items ??
        res?.results ??
        res?.data?.itens ??
        res?.data?.items ??
        res?.data?.results ??
        res?.data ??
        res ??
        [];

      this.setState({
        lista: Array.isArray(lista) ? lista : [],
        loading: false,
      });
    } catch (err) {
      console.error(
        this.props.lang.telaDeCadastroDeInstalador?.mensagens?.erroAoBuscarInstaladores,
        err
      );
      this.setState({ loading: false });
    }
  }

  baixar = (arquivo) => {
    if (!arquivo?.nome) return;

    this.props.api
      .get('/file/base64/' + arquivo.nome)
      .then((data) => {
        downloadBase64File(
          data,
          arquivo.descricao ? arquivo.descricao : arquivo.nome,
          arquivo.tipo
        );
      })
      .catch(() => {});
  };

  formatarData = (iso) => (iso ? new Date(iso).toLocaleDateString() : '');

  renderInstrucoesApp = () => {
    return (
      <div
        style={{
          padding: 12,
          borderRadius: 8,
          border: '1px solid #e0e0e0',
          background: '#fafafa',
          marginBottom: 12,
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 6 }}>
            {this.props.lang.telaDeConsultaDeInstaladores.instrucoesAppTitulo}
        </div>

        <ol style={{ margin: 0, paddingLeft: 18 }}>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesAppPasso1}</li>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesAppPasso2}</li>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesAppPasso3}</li>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesAppPasso4}</li>
        </ol>
      </div>
    );
  };

  renderInstrucoesDesktop = () => {
    return (
      <div
        style={{
          padding: 12,
          borderRadius: 8,
          border: '1px solid #e0e0e0',
          background: '#fafafa',
          marginBottom: 12,
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 6 }}>
            {this.props.lang.telaDeConsultaDeInstaladores.instrucoesDesktopTitulo}
        </div>

        <ol style={{ margin: 0, paddingLeft: 18 }}>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesDesktopPasso1}</li>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesDesktopPasso2}</li>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesDesktopPasso3}</li>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesDesktopPasso4}</li>
            <li>{this.props.lang.telaDeConsultaDeInstaladores.instrucoesDesktopPasso5}</li>
        </ol>
      </div>
    );
  };

  renderTabela = (titulo, itens, instrucoes) => {
    return (
      <div style={{ marginBottom: 28 }}>
        <h5 style={{ marginBottom: 12 }}>{titulo}</h5>

        {instrucoes}

        {itens.length === 0 ? (
          <div style={{ opacity: 0.7 }}>Nenhuma versão disponível.</div>
        ) : (
          <Table
            hover
            responsive
            style={{
              marginBottom: 0,
              minWidth: '100%',
              width: '100%',
              tableLayout: 'fixed',
              backgroundColor: '#fff',
              display: 'table',
            }}
          >
            <thead style={{ backgroundColor: '#eef1f4' }}>
              <tr>
                <th style={{ width: '12%' }}>{this.props.lang.codigo}</th>
                <th style={{ width: '12%' }}>
                  {this.props.lang.telaDeCadastroDeInstalador?.numeroDaVersao}
                </th>
                <th style={{ width: '14%' }}>
                  {this.props.lang.telaDeCadastroDeInstalador?.dataDeLiberacao}
                </th>
                <th style={{ width: '32%' }}>
                  {this.props.lang.telaDeCadastroDeInstalador?.alteracoes}
                </th>
                <th style={{ width: '22%' }}>
                  {this.props.lang.telaDeCadastroDeInstalador?.arquivo}
                </th>
                <th style={{ width: '8%', textAlign: 'center' }}>
                  {this.props.lang.telaDeCadastroDeInstalador?.download}
                </th>
              </tr>
            </thead>

            <tbody style={{ backgroundColor: '#fff' }}>
              {itens.map((item, idx) => {
                const maisRecente = idx === 0;

                return (
                  <tr
                    key={item.id}
                    style={{
                      backgroundColor: '#fff',
                      fontWeight: maisRecente ? 600 : 400,
                    }}
                  >
                    <td style={{ width: '12%' }}>{item.id}</td>

                    <td style={{ width: '12%' }}>
                      {item.numeroDaVersao +
                        (maisRecente
                          ? ` (${this.props.lang.telaDeCadastroDeInstalador?.ultimaVersao})`
                          : '')}
                    </td>

                    <td style={{ width: '14%' }}>{this.formatarData(item.dataDeLiberacao)}</td>

                    <td style={{ width: '32%', whiteSpace: 'pre-wrap' }}>{item.alteracoes}</td>

                    <td style={{ width: '22%', wordBreak: 'break-word' }}>
                      {item.arquivoDeInstalacao?.descricao}
                    </td>

                    <td style={{ width: '8%', textAlign: 'center' }}>
                      <FontAwesomeIcon
                        icon={faDownload}
                        style={{ cursor: item.arquivoDeInstalacao ? 'pointer' : 'not-allowed', opacity: item.arquivoDeInstalacao ? 1 : 0.4 }}
                        title="Baixar"
                        onClick={() => this.baixar(item.arquivoDeInstalacao)}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </div>
    );
  };

  renderTitulo = () => {
    return (
      <div
        id="div-titulo-formulario"
        style={{
          width: '100%',
          margin: 0,
          paddingTop: 0,
          paddingLeft: 10,
          paddingRight: 10,
          height: 45,
          display: 'flex',
          backgroundColor: LayoutParams.colors.corDoTemaPrincipal,
          color: LayoutParams.colors.corSecundaria,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div
          style={{
            display: 'table-cell',
            width: '0',
            overflowX: 'visible',
            fontSize: 30,
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          <div>{this.props.lang.telaDeConsultaDeInstaladores?.instaladores}</div>
        </div>
      </div>
    );
  };

  render() {
    const { lista, loading } = this.state;

    const ordenarPorDataDesc = (a, b) =>
      new Date(b.dataDeLiberacao || 0) - new Date(a.dataDeLiberacao || 0);

    const aplicativos = (lista || [])
      .filter((x) => x.tipoDeInstalador === 'Aplicativo')
      .sort(ordenarPorDataDesc);

    const desktops = (lista || [])
      .filter((x) => x.tipoDeInstalador === 'Desktop')
      .sort(ordenarPorDataDesc);

    return (
      <div style={{ width: '100%' }}>
        {this.renderTitulo()}

        <div style={{ padding: 20 }}>
          {loading ? (
            <div>{this.props.lang.telaDeCadastroDeInstalador?.carregando}</div>
          ) : (
            <>
              {this.renderTabela(
                this.props.lang.telaDeCadastroDeInstalador?.aplicativo,
                aplicativos,
                this.renderInstrucoesApp()
              )}

              {this.renderTabela(
                this.props.lang.telaDeCadastroDeInstalador?.desktop,
                desktops,
                this.renderInstrucoesDesktop()
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}